export default {
  "nav": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
    "aquariums": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aquariums"])},
    "plants": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plants"])},
    "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profile"])}
  },
  "login": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign In"])},
    "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username"])},
    "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
    "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
    "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invalid username or password"])}
  },
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome back"])},
    "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hello! 👋"])},
    "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your aquariums are doing great."])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
    "quickAccess": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quick access"])}
  },
  "aquariums": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Aquariums"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monitor your tanks"])},
    "status": {
      "healthy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Healthy"])},
      "attention": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attention"])}
    }
  },
  "plants": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plants"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your aquatic flora"])},
    "sections": {
      "foreground": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Foreground"])},
      "midground": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Midground"])},
      "background": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Background"])}
    }
  },
  "pwa": {
    "tagline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your aquarium companion"])},
    "install": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Install app"])},
    "loginCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Install AquaScaper on your device"])},
    "android": {
      "promptDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Install AquaScaper on your home screen for the best experience."])},
      "manualDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add AquaScaper to your home screen:"])},
      "step1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap the menu"])},
      "step2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap \"Add to Home Screen\""])},
      "step3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap \"Add\" to confirm"])}
    },
    "ios": {
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add AquaScaper to your home screen for the best experience:"])},
      "step1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap the Share button"])},
      "step2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap \"Add to Home Screen\" then \"Add\""])},
      "safariOnly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Only works in Safari on iOS"])}
    },
    "desktop": {
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AquaScaper is designed for mobile."])},
      "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open this page on your phone or tablet to install it on your home screen."])}
    }
  },
  "profile": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profile"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account & settings"])},
    "memberSince": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Member since"])},
    "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
    "items": {
      "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifications"])},
      "language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])},
      "units": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Units"])},
      "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About AquaScaper"])}
    }
  }
}